{
    "FormEngineTextareaElement": {
        "title": "Textarea"
    },
    "mask": {
        "FormEngineTextareaElement": {
            "groupTitle": "Textarea",
            "showError": "Show Error",
            "rows": "Rows"
        }
    }
}